<template>
  <div class="container">
    <!-- Check that the SDK client is not currently loading before accessing is methods -->
    <div v-if="!this.$auth.loading" class="row">
      <div class="col-sm">
        {{ $auth.user ? $auth.user.name : '' }}
      </div>
      <div class="col-sm">
        {{ $auth.user ? $auth.user.email : '' }}
      </div>
      <div class="col-sm">
        <!-- show login when not authenticated -->
        <button v-if="!this.$auth.isAuthenticated" type="button" class="btn btn-primary" @click="login">Log in</button>
        <!-- show logout when authenticated -->
        <button v-if="this.$auth.isAuthenticated" type="button" class="btn btn-primary" @click="logout">Log out</button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Auth0Login",
    components: {
    },
    created() {
      if (this.$auth.isAuthenticated) {
        //this.$auth.getTokenSilently().then(t => window.localStorage.setItem('vue.auth.token', t))
      }
    },
    methods: {
      // Log the user in
      login() {
        this.$auth.loginWithRedirect({
          redirect_uri: window.location.href
        });
      },
      // Log the user out
      logout() {
        this.$auth.logout({
          returnTo: window.location.href
        });
      },
      log() {
        this.$auth.getTokenSilently().then(t => console.log(t))
      }
    }
  };
</script>
